<template>
  <div>
    <a-form :model="searchForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
      <a-row>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="标签名称">
            <a-input v-model="searchForm.label_name" allowClear placeholder="请输入标签名称" />
          </a-form-item>
        </a-col>
        <a-col :xs="8" :sm="6" :md="6" :lg="4" :xl="4">
          <a-form-item label="标签序号">
            <a-input v-model="searchForm.id" allowClear placeholder="请输入标签序号" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="发布平台">
            <a-select v-model="searchForm.line_id" allowClear show-search option-filter-prop="children" placeholder="请选择发布平台" style="width: 100%">
              <a-select-option v-for="item in platformList" :key="item.id" :value="item.id">{{
                item.org
              }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 搜索按钮 -->
        <a-button type="primary" icon="search" style="margin-right: 20px" @click="search">查询</a-button>
        <a-button type="primary" icon="delete" ghost @click="handleClear">清空</a-button>
      </a-row>
    </a-form>
    <!-- 表格 -->
    <a-tabs default-active-key="1" v-model="searchForm.auto_state" @change="changeTab">
      <a-tab-pane v-for="op in tabOptions" :key="op.key" :tab="op.name">
        <a-table row-key="id" :columns="columns" :loading="loading" :data-source="data" :pagination="pagination" style="margin-top: 20px" @change="handleTableChange">
          <template slot="article_total" slot-scope="text">
            <span style="color: #1890ff">{{ text }}</span>
          </template>

          <template slot="project" slot-scope="text, record">
            <span>{{ getOrg(record) }}</span>
          </template>

          <template slot="autoArticle" slot-scope="text, record">
            <span style="display:inline-block; min-width: 20px; margin-right: 10px;">{{ text && text.length }}</span>
            <a @click="handleViewAutoArticle(record)">查看</a>
          </template>
        </a-table>
      </a-tab-pane>
    </a-tabs>
    <viewArticle ref="viewArticle" :rawPlatList="rawPlatList" :platformList="platformList" @update="getList"/>
  </div>
</template>
<script>
import { ref, reactive, onMounted, toRefs, getCurrentInstance } from '@vue/composition-api'
import { searchForm, columns, form } from './business/filialeList'
import { strategyCommand } from './business/tableList'
import pagination from '@/composables/pagination'
import compuedFun from './business/index'
import api from '@/api/'
import viewArticle from './components/viewArticle'

export default {
  components: { viewArticle },

  setup(props, { root }) {
    // 获取当前实例
    const _this = getCurrentInstance()
    // 分页信息
    const pagData = pagination()
    const { handleTableChange } = pagData

    const state = reactive({
      ...pagData,
      columns,
      times: [],
      platformList: [],
      rawPlatList: [],
      searchForm: { ...searchForm },
      tabOptions: [
        { name: '待审核', key: '0' },
        { name: '审核通过', key: '1' },
        { name: '重新匹配', key: '2' },
      ]
    })

    const viewArticle = ref(null)

    onMounted(async () => {
      await methods.getPlatform()
      methods.getList()
    })

    const methods = {
      search() {
        _this.pagination.current = 1
        this.getList()
      },

      changeTab() {
        this.getList()
      },

      async getList() {
        _this.loading = true
        _this.data = []
        const res = await api.autoLabelItems({
          ..._this.searchForm,
          page: _this.pagination.current,
          per_page: _this.pagination.pageSize
        }).finally(() => {
          _this.loading = false
        })
        const { list, pagination } = res.data
        _this.data = list
        _this.pagination.total = Number(pagination.total)
      },

      async getPlatform() {
        const res = await api.LineListNew()
        state.rawPlatList = res.data || []
        state.platformList = res.data.filter(item => {
          return item.parent_id === 0
        })
      },

      handleClear() {
        state.searchForm = { ...searchForm }
        state.times = []
        this.search()
      },
      // 关联列表
      lookArticle(item) {
        _this.$router.push(`/relevancy/list/${item.id}?&title=${item.title}&org=${item.org}&line_id=${item.line_id}`)
      },

      handleViewAutoArticle(record) {
        const tab = this.tabOptions.find(op => op.key === this.searchForm.auto_state)
        viewArticle.value.open(record || [], tab)
      },

      getOrg(record) {
        const obj = this.rawPlatList.find(item => String(item.project) === record.project && String(item.type) === record.type && String(item.staff_style) === record.staff_style)
        return obj ? obj.org : ''
      },
      handleTableChange
    }

    return {
      ...compuedFun(),
      ...toRefs(state),
      ...pagination(),
      ...methods,
      viewArticle
    }
  }
}
</script>
